import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import sidService from "@/services/sidService";
import ProductDetail from "@/components/ProductDetail.vue";
import ProductTable from '@/components/ProductTable.vue';
import ResellerList from '@/components/ResellerList.vue';
import EventsList from "@/components/EventsList.vue";

const routes = [
    {
        path: '/',
        component: Home,
        name: 'Home'
    },
    {
        path: '/prodotto/:id/:slug?',
        name: 'ProductDetail',
        component: ProductDetail,
        props: true
    },
    {
        path: '/preventivo',
        name: 'ProductTable',
        component: ProductTable,
        props: true
    },
    {
        path: '/dove-acquistare',
        name: 'ResellerList',
        component: ResellerList,
        props: true
    },
    {
        path: '/eventi',
        name: 'EventsList',
        component: EventsList,
        props: true
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.afterEach((to, from) => {
    if(to.name === from.name) return
    sidService.logAccess({ path: to.path })
    document.getElementById("app").scrollIntoView()
})

export default router